import { AgentDashboardView } from "./agentDashboardView";
import {
  LoadingAFY,
  typeLoaders,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import React from "react";

export const AgentDashboard = () => {
  const [loading, setLoading] = React.useState(false);
  return (
    <>
      <LoadingAFY
        loading={loading}
        backgroundColor={themeCore.colors.backgroundLoader}
        typeAnimation={typeLoaders.LogoAfy}
        sizeAnimation={65}
        textLoading={"Cargando..."}
        textLoadingColor={themeCore.colors.third}
        spinnerColor={themeCore.colors.third}
      />

      <AgentDashboardView />
    </>
  );
};
